import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "text-gray-700" }


import ModalBox from "@/components/v2/Modal/ModalBox.vue";
import { useTasksStore } from "@/stores/v2";
import { storeToRefs } from "pinia";

interface Props {
  showModal: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InstructionsModal',
  props: {
    showModal: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

const { activeTask } = storeToRefs(useTasksStore());

const handleClose = () => {
  emit('close');
};

return (_ctx: any,_cache: any) => {
  return (_ctx.showModal)
    ? (_openBlock(), _createBlock(ModalBox, {
        key: 0,
        onClose: handleClose
      }, {
        header: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Instructions ")
        ])),
        main: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(activeTask)?.description || 'No instructions available for this task.'), 1)
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            onClick: handleClose,
            type: "button",
            class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10"
          }, " Close ")
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})